import { DetailsChildrenTab, KanbanBoard, type DetailsPageProps } from 'app/main/components/page-layouts';

import ChronologyListItem from 'app/main/modules/chronology/ChronologyListItem';
import MarketingActionsListItem from 'app/main/modules/marketingactions/MarketingActionsListItem';
import DemsListItem from 'app/main/modules/dems/DemsListItem';
import CommercialCampaignsListItem from 'app/main/modules/commercialcampaigns/CommercialCampaignsListItem';
import OpportunitiesListItem from 'app/main/modules/opportunities/OpportunitiesListItem';
import ContractsListItem from 'app/main/modules/contracts/ContractsListItem';
import OrdersListItem from 'app/main/modules/orders/OrdersListItem';
import ProjectsListItem from 'app/main/modules/projects/ProjectsListItem';
import ActivitiesListItem from 'app/main/modules/activities/ActivitiesListItem';
import WorkReportsListItem from 'app/main/modules/workreports/WorkReportsListItem';
import TicketsListItem from 'app/main/modules/tickets/TicketsListItem';

import KpisGoalsValuesDetailsTab from 'app/main/submodules/kpis/tabs/KpisGoalsValuesDetailsTab';

import UsersDetailsTab from './tabs/UsersDetailsTab';
import UsersContactTab from './tabs/UsersContactTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <UsersDetailsTab {...props} />
	},
	{
		id: 'contacts',
		title: 'TAB_CONTACTS',
		disabled: ({ isEdit }) => isEdit,
		content: ({ model }) => <UsersContactTab itemUid={model.user_uid} />
	},
	{
		id: 'kpis-goals',
		title: 'MODULE_SYS_KPIS_GOALS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('sys_kpis_goals') || authorizer.cannot('view', 'sys_kpis_goals'),
		content: ({ model, updateRefresh, refresh }) => (
			<KpisGoalsValuesDetailsTab
				aggregation={{ module: 'users', value: model.user_uid }}
				refresh={refresh}
				updateRefresh={updateRefresh}
			/>
		)
	},
	{
		id: 'chronology',
		title: 'MODULE_CHRONOLOGY_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('chronology') || authorizer.cannot('view', 'chronology'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="chronology"
				content={{ type: 'list', itemLayout: ChronologyListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'chro_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
			/>
		)
	},
	{
		id: 'activities',
		title: 'MODULE_ACTIVITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('activities') || authorizer.cannot('view', 'activities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="activities"
				content={{ type: 'list', itemLayout: ActivitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'acti_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
			/>
		)
	},
	{
		id: 'activities-kanban',
		title: 'DETAILS_USERS_TAB_ACTIVITIES_KANBAN',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('activities') || authorizer.cannot('view', 'activities'),
		content: ({ model }) => (
			<KanbanBoard
				module="activities"
				bucket="activities_statuses"
				defaultFilters={[
					{ filt_field: 'acti_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
				baseModel={{ acti_user_assigned_uid: model.user_uid }}
			/>
		)
	},
	{
		id: 'opportunities',
		title: 'MODULE_OPPORTUNITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('opportunities') || authorizer.cannot('view', 'opportunities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="opportunities"
				content={{ type: 'list', itemLayout: OpportunitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'oppo_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
			/>
		)
	},
	{
		id: 'opportunities-kanban',
		title: 'DETAILS_USERS_TAB_OPPORTUNITIES_KANBAN',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('opportunities') || authorizer.cannot('view', 'opportunities'),
		content: ({ model }) => (
			<KanbanBoard
				module="opportunities"
				bucket="opportunities_statuses"
				defaultFilters={[
					{ filt_field: 'oppo_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
				baseModel={{ oppo_user_assigned_uid: model.user_uid }}
			/>
		)
	},
	{
		id: 'marketingactions',
		title: 'MODULE_MARKETINGACTIONS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('marketingactions') || authorizer.cannot('view', 'marketingactions'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="marketingactions"
				content={{ type: 'list', itemLayout: MarketingActionsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'maac_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
			/>
		)
	},
	{
		id: 'commercialcampaigns',
		title: 'MODULE_COMMERCIALCAMPAIGNS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('commercialcampaigns') || authorizer.cannot('view', 'commercialcampaigns'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="commercialcampaigns"
				content={{ type: 'list', itemLayout: CommercialCampaignsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'cmcp_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
			/>
		)
	},
	{
		id: 'dems',
		title: 'MODULE_DEMS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) => isModuleDisabled('dems') || authorizer.cannot('view', 'dems'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="dems"
				content={{ type: 'list', itemLayout: DemsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'dems_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
			/>
		)
	},
	{
		id: 'contracts',
		title: 'MODULE_CONTRACTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('contracts') || authorizer.cannot('view', 'contracts'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="contracts"
				content={{ type: 'list', itemLayout: ContractsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'cntr_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
			/>
		)
	},
	{
		id: 'orders',
		title: 'MODULE_ORDERS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) => isModuleDisabled('orders') || authorizer.cannot('view', 'orders'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="orders"
				content={{ type: 'list', itemLayout: OrdersListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'ords_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
			/>
		)
	},
	{
		id: 'projects',
		title: 'MODULE_PROJECTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('projects') || authorizer.cannot('view', 'projects'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="projects"
				content={{ type: 'list', itemLayout: ProjectsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'proj_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
			/>
		)
	},
	{
		id: 'workreports',
		title: 'MODULE_WORKREPORTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('workreports') || authorizer.cannot('view', 'workreports'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="workreports"
				content={{ type: 'list', itemLayout: WorkReportsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'wore_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
			/>
		)
	},
	{
		id: 'tickets',
		title: 'MODULE_TICKETS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('tickets') || authorizer.cannot('view', 'tickets'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="tickets"
				content={{ type: 'list', itemLayout: TicketsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'tick_user_assigned_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
			/>
		)
	}
];

export default tabs;
